module.exports = __webpack_public_path__ + "img/13.3e35fc90.jpg";